import graphql__80f11c9d27780a72bbb1 from "./__generated__/Event_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";

import SubscribeToEventButton from "./SubscribeToEventButton";
import TitleBarWithAction from "../ParticipativeModule/TitleBarWithAction";
import { isUnauthorized } from "../Utils/authorizations";
import EventDetails from "./EventDetails";
import PushableContainer from "../Utils/PushableContainer";
import ModalOutlet from "../Routing/ModalOutlet";

const Event = props => {
  const participativeModule = useFragment(
    Event_participativeModule,
    props.participativeModule
  );
  const { contributionsSubmissionAuthorized } = participativeModule.authorizations;

  const isSubscriptionAuthorized = !isUnauthorized(contributionsSubmissionAuthorized);

  const titleAction = isSubscriptionAuthorized && (
    <SubscribeToEventButton
      participativeModule={participativeModule}
      className="btn btn-primary btn-block-md box-shadow-lg btn-expand-height padding-sm"
    />
  );

  return (
    <PushableContainer className="container event-container">
      <TitleBarWithAction resource={participativeModule} action={titleAction} />

      <EventDetails participativeModule={participativeModule} />

      <ModalOutlet />
    </PushableContainer>
  );
};

const Event_participativeModule = graphql__80f11c9d27780a72bbb1;

export default Event;
